export class TransactionInfo {
  id: number;
  numeroCartao: string;
  codAuth: string;
  codTerm: string;
  nsuTerminal: string;
  nsuHost: string;
  data: string;
  hora: string ;
  valor: string;
  qtdParcelas: string;
  bandeira: string;
  modalidade: string;
  codigoSimulador: string;
  recibo: string;
  cpfCnpj: string;
  vendaTx: string;
  confirmaVendaTx: string;
  etapaProcessamento: string;
  codigoMensagem: string;
  codigoProcessamento: string;
  tipoTaxa: string;
  status: string;
  valorSemTaxas: string;
  tipoTransacao: string;
  transacaoEstornoId: number;
  estornoVendaTx: string;
  pinSimuladorId: number;
  modeloCaptura: string;
  reciboUsuario: string;
}
